<template>
  <main>
    <login-personalize-list />
  </main>
</template>

<script>
import LoginPersonalizeList from "@components/modules/login-personalize/list/LoginPersonalizeList";
import { redirectUtils } from "../../packages/util/redirect/redirectUtils";

export default {
  components: {
    LoginPersonalizeList,
  },

  data() {
    return {};
  },

  created() {},

  beforeMount() {
    const url = this.isPartner ? redirectUtils.mountUrl('/new/parceiro/configuracoes/cadastros/tela') : redirectUtils.mountUrl('/new/estabelecimento/configuracoes/cadastros/tela');
    location.assign(url)
  },

  computed: {
    isPartner() {
      return this.$store.state.users.user.tipo === "PARCEIRO";
    },
  },

  methods: {},

  beforeDestroy() {},

  watch: {},
};
</script>

<style lang="scss" scoped>
</style>
